/* eslint-disable array-callback-return */
import { Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useCallback, useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { post } from '../resources/onboard/PaymentProvider';
import { BONUS_POOL_DASHBOARD_ICON, DASHBOARD_USER_ICON } from '../utils/Constants/ClassName';
import { API_ENDPOINTS } from '../utils/Constants/ConstantData';
import BonusDetails from './BonusDetails';
import { NUMBER } from '../utils/Constants/MagicNumber';

const BonusPoolDetails =(props) =>{
    const {identity} = props;

    return(
      <div className={`${(identity?.company?.is_bonus_pool_enabled && identity?.user_type !== 'worker') ? 'dash-two-box' : 'dash-one-box'}`}>
        <Grid container spacing={3} className="dashboard-bonus-sec dashboard-pool-sec">
         {identity && <BonusDetails identity={identity}/>}
          {(identity?.company?.is_bonus_pool_enabled && identity?.user_type !== 'worker') && <BonusPool identity={identity} />}
          {/* <SavedHours/> */}
        </Grid>
    </div>
    );
};
export default BonusPoolDetails;

const BonusPool = ({identity}) => {
  const [filterval, setFilterval] = useState('all');
  const [companybonusPool, setCompanybonusPool] = useState({company_pool:NUMBER.ZERO});
  const notifiy = useNotify();

  const companyBonusPoolApiCall = useCallback(async (query, companyId) => {
    try {
      const finalRequest = {
        jsonrpc: '2.0',
        company_id: companyId,
        filter: query
      };
      const bonusPoolData = await post(API_ENDPOINTS.COMPANY_BONUS_POOL, finalRequest) as any;
      if (bonusPoolData?.status === 'success') {
        setCompanybonusPool(bonusPoolData);
      }else{
        setCompanybonusPool({company_pool:NUMBER.ZERO});
        notifiy('Something went wrong in bonus pool api.');
      }
    } catch (error) {
      setCompanybonusPool({company_pool:NUMBER.ZERO});
      notifiy(error);
    }
  }, [notifiy]);

  useEffect(() => {
    if (identity?.company_id) {
      companyBonusPoolApiCall('all', identity?.company_id);
    }
  }, [companyBonusPoolApiCall, identity?.company_id]);

  const handleChange = (event: SelectChangeEvent, eventName) => {
    switch (eventName.props.children) {
      case 'Current Period':
          companyBonusPoolApiCall('current_period',identity?.company_id)
          break;
          case 'Previous Period':
            companyBonusPoolApiCall('pevious_period',identity?.company_id)
          break;
          case 'Current Year':
            companyBonusPoolApiCall('current_year',identity?.company_id)
          break;
          default:
            companyBonusPoolApiCall('all',identity?.company_id)
          break;
    }
    setFilterval(event.target.value);
  };

  const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      });

  return(
    <>
    <Grid item xs={12} sm={4} md={4} lg={4} className='dash-bonus-grid-item grid-item-boxes'>
    <div className='bonus-pool-box'>
    <Box className='dashboard-card-top-head'>
      <div className='dashboard-card-left-head'>
      <Typography variant='h3'>Bonus Pool</Typography>
      </div>
      <div className='dashboard-card-right-head'>
      <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth className='no-translate'>
      <Select
          labelId='demo-simple-select-helper-label'
          id='demo-simple-select-helper'
          value={filterval}
          onChange={handleChange}
          MenuProps={{ disableScrollLock: true }}
        >
          <MenuItem value={'all'} className='no-translate'>All</MenuItem>
          <MenuItem value={'current_period'} selected className='no-translate'>Current Period</MenuItem>
          <MenuItem value={'pevious_period'} className='no-translate'>Previous Period</MenuItem>
          <MenuItem value={'current_year'} className='no-translate'>Current Year</MenuItem>
        </Select>
      </FormControl>
    </Box>
      </div>
      </Box>

      <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <div className='dash-bonus-panel dash-pool-panel'>
                <div className='dash-bonus-panel-left'>
                <Typography variant='h4'><strong>{formatter.format(companybonusPool?.company_pool ? companybonusPool?.company_pool : NUMBER.ZERO )}</strong></Typography>
                <Typography variant='subtitle2'>{identity?.company?.company_pool_label ? identity?.company?.company_pool_label : 'Company'}</Typography>
                </div>
                <div className='bonus-dollar-icon'>
                {BONUS_POOL_DASHBOARD_ICON()}
                </div>
                </div>
            </Grid>
        </Grid>
    </div>
    </Grid>
    </>
  )
}

const SavedHours = () => {
  return(
    <>
      <Grid item xs={12} sm={4} md={4} lg={4} className='dash-bonus-grid-item grid-item-boxes'>
        <div className='bonus-pool-box'>
          <Box className='dashboard-card-top-head'>
            <div className='dashboard-card-left-head'>
              <Typography variant='h3'>Saved Hrs.</Typography>
            </div>
            <div className='dashboard-card-right-head'>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth className='no-translate'>
                  <Select
                    labelId='demo-simple-select-helper-label'
                    id='demo-simple-select-helper'
                    MenuProps={{ disableScrollLock: true }}
                  >
                    <MenuItem value={'all'} className='no-translate'>All</MenuItem>
                    <MenuItem value={'current_period'} selected className='no-translate'>Current Period</MenuItem>
                    <MenuItem value={'pevious_period'} className='no-translate'>Previous Period</MenuItem>
                    <MenuItem value={'current_year'} className='no-translate'>Current Year</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <div className='dash-bonus-panel saved-worker-panel'>
                <div className='dash-bonus-panel-left'>
                  <Typography variant='h4'><strong>4,800 hr.</strong></Typography>
                  <Typography variant='subtitle2'>Workers</Typography>
                </div>
                <div className='bonus-dollar-icon'>
                  {DASHBOARD_USER_ICON()}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </>
  );
};
